export const jsonToGeojson = json => {
  // parse json go geojson
  return {
    type: "FeatureCollection",
    features: json.map(item => ({
      type: "Feature",
      properties: { ...item, geom: null },
      geometry: { ...item.geom }
    }))
  };
};

export const pointArrayToGeojson = data => {
  return {
    type: "FeatureCollection",
    features: data.map(coordinates => ({
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates }
    }))
  };
};
